<style>
  hr {
    border-bottom: 1px solid var(--tui-background-neutral-1-hover);
  }
  .extend-width {
    width: calc(100% + 2rem);
    margin-left: -1rem;
  }
</style>
@let fileCatGroup = $fileCatGroups();
@let isInsideSummary = $isInsideSummary();
@if (
  (permissionService.canSendRequestByEmail$ | async) && fileCatGroup.length
) {
  <section>
    <h6 class="typo-h6 mt-8 pb-4.5">
      {{ 'request_form.files.download.send_by_email.title' | translate }}
    </h6>
    <form [formGroup]="formGroup">
      <tui-textfield
        class="mb-4 x-white"
        tuiTextfieldSize="m"
        [tuiTextfieldCleaner]="true"
      >
        <label tuiLabel>{{
          'request_form.files.download.send_by_email.email_placeholder'
            | translate
        }}</label>
        <input [formControlName]="FormFields.EmailToSendFiles" tuiInput />
      </tui-textfield>
      <tui-error [formControlName]="FormFields.EmailToSendFiles"></tui-error>
    </form>
    <tui-accordion
      size="m"
      [closeOthers]="false"
      [ngClass]="{ 'extend-width': !isInsideSummary }"
    >
      @for (fcGroup of fileCatGroup; track fcGroup.id) {
        <button tuiAccordion>
          <article
            class="py-4.5 flex flex-1 min-w-0 items-center justify-between gap-3"
          >
            <p class="typo-body-m font-medium">
              {{ fcGroup.name }}
            </p>
            <input
              tuiCheckbox
              type="checkbox"
              size="m"
              [(ngModel)]="groupFilesAllSelected[fcGroup.id]"
              (ngModelChange)="onSelectAllGroupFiles(fcGroup.id)"
              (click)="$event.stopPropagation()"
            />
          </article>
        </button>
        <tui-expand class="no-y-padding-accordion-btn">
          <ol
            class="list-decimal ps-5 typo-body-s leading-5 text-(--tui-text-primary) marker:text-(--tui-text-tertiary)"
          >
            @for (category of fcGroup.fileCats; track category.id) {
              <li
                class="mt-3 first:mt-0 wrap-break-word x-text-02 text-xs font-semibold opacity-80"
              >
                <article class="flex">
                  <input
                    tuiCheckbox
                    type="checkbox"
                    class="me-2"
                    size="s"
                    [(ngModel)]="
                      selectedFilesToDownload[fcGroup.id][category.id]
                    "
                    (ngModelChange)="checkAllFilesSelected(fcGroup.id)"
                  />
                  {{ category.name }}
                </article>
              </li>
            }
          </ol>
        </tui-expand>
      }
    </tui-accordion>
    <button
      tuiButton
      appearance="secondary"
      type="button"
      size="m"
      class="mt-4.5"
      [disabled]="formGroup.invalid || $sending()"
      (click)="sendFilesByEmail()"
    >
      {{ 'request_form.files.download.send_by_email.send_button' | translate }}
    </button>
  </section>
}
